var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHat1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.22284 13.5L2.11801 17.5626C1.81453 18.2196 2.11863 19.0057 2.77529 19.2616C8.72288 21.5795 15.2771 21.5795 21.2247 19.2616C21.8814 19.0057 22.1855 18.2196 21.882 17.5626L19.7772 13.5H4.22284Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 10V12H5V10C5 6.13401 8.13401 3 12 3C15.866 3 19 6.13401 19 10Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHat1);
export default __webpack_public_path__ + "static/media/hat-1.489b1dcf95a5c7a778734a996f003f01.svg";
export { ForwardRef as ReactComponent };